document.documentElement.classList.remove('no-js');

function initializeTheme(root = document) {
  root.querySelectorAll('.comparison').forEach((comparison) => {
    const range = comparison.querySelector('.comparison__range');
    if (!range || range.dataset.ready === 'true') return;
    range.dataset.ready = 'true';
    const update = () => {
      comparison.style.setProperty('--comparison-position', `${range.value}%`);
    };
    range.addEventListener('input', update);
    update();
  });

  root.querySelectorAll('.mobile-menu nav a').forEach((link) => {
    if (link.dataset.ready === 'true') return;
    link.dataset.ready = 'true';
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initializeTheme());
document.addEventListener('shopify:section:load', (event) => initializeTheme(event.target));
